	<template>
        <!-- 量表题 -->
    <div class="inputvalue">
        <div class="option-box">
            <template v-if="data.displayStyle !== 0">
                <div 
                    v-for="(item, index) in data.orderSetting"
                    :key="index"
                    class="option"
                >
                    <transition name="el-fade-in-linear">
                        <span v-show="data.startNum + index == isTipShow" class="tip">{{data.startNum + index}}</span>
                    </transition>
                    <img 
                        class="option-img"
                        :src="
                            parseInt(data.userAnswer) >= data.startNum + index ? 
                            rateDataList[data.displayStyle].unCheckedImg :
                            rateDataList[data.displayStyle].checkedImg
                        "
                        :alt="data.startNum + index"
                        @click="itemClick(data.startNum + index)"
                    >
                </div>
            </template>
            <template v-else>
                <p 
                    class="scale-btn-item"
                    :class="{'scale-btn-item-active': data.userAnswer >= data.startNum + index}"
                    :style="{opacity: data.userAnswer >= data.startNum + index ? (1 / data.orderSetting * index  + 0.1) : 1}"
                    v-for="(item, index) in data.orderSetting"
                    :key="index"
                    @click="itemClick(data.startNum + index)"
                >{{data.startNum + index}}</p>
            </template>
        </div>
        <div class="tips-box" >
            <span>{{ data.leftText }}</span>
            <span>{{ data.rightText }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'QuesScale',
    props: {
        data: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            rateDataList: [
                {
                    value: 'number',
                    id: 0
                },
                {
                    checkedImg:require('@/assets/rate/star_def.png'),
                    unCheckedImg: require('@/assets/rate/star_sel.png'), 
                    value: 'star',
                    id: 1
                },
                {
                    checkedImg:require('@/assets/rate/heart_def.png'),
                    unCheckedImg: require('@/assets/rate/heart_sel.png'),
                    value: 'heart',
                    id: 2
                },
                {
                    checkedImg:require('@/assets/rate/laugh_def.png'),
                    unCheckedImg: require('@/assets/rate/laugh_sel.png'),
                    value: 'smile',
                    id: 3
                },
                {
                    checkedImg:require('@/assets/rate/good_def.png'),
                    unCheckedImg: require('@/assets/rate/good_sel.png'),
                    value: 'thumb',
                    id: 4
                }
            ],
            isTipShow: -2
        }
    },
    methods: {
        itemClick(e) {
            this.data.userAnswer = e
            this.$emit('userAnswerChange', this.data)
            this.isTipShow = e
            setTimeout(() => {
                this.isTipShow = -2
            }, 1000)
        },
    }
    
}
</script>

<style scoped lang="scss">

.inputvalue {
    width: 100%;
    .tips-box, .option-box{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 12px;
        /deep/.el-radio{
            margin: 0 !important
        }
    }
    .tips-box{
        color: #999;
        font-size: 12px;
    }
    
    .option-box {
        .option{
            position: relative;
            
            .tip{
                border-radius: 4px;
                color: #fff;
                height: 14px;
                font-size: 13px;
                line-height: 14px;
                background-color: #2672ff;
                padding: 4px 10px;
                position: absolute;
                text-align: center;
                left: -2px;
                top: -24px;
                z-index: 9;
            }
        }
        .option-img{
            cursor: pointer;
            width: 24px;
            height: 22px;
        }
    }
}
.scale-btn-item{
    flex: 1;
    font-size: 12px;
    background-color: rgba(241,243,246,.5);
    border-radius: 4px;
    color: #333;
    cursor: pointer;
    height: 28px;
    line-height: 28px;
    text-align: center;
}
.scale-btn-item+.scale-btn-item{
    margin-left: 4px;
}
.scale-btn-item-active{
    color: #fff;
    background-color: rgb(38, 114, 255);
}
</style>
